import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { APP_BASE_HREF } from '@angular/common';
import { environment } from '../environments/environment';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ContextService } from './services/context.service';
import { TimeService } from './services/time.service';
import { ApiService } from './services/api.service';
import { DataService } from './services/data.service';
import { ColorService } from './services/color.service';
import { PeProviderService } from './services/pe-provider.service';

import { AppComponent } from './app.component';
import { MapComponent } from './components/map/map.component';
import { TimeBarComponent } from './components/time-bar/time-bar.component';

import { SliderModule, ChartModule, DialogModule } from 'primeng/primeng';
import { PropertySelectorComponent } from './components/property-selector/property-selector.component';
import { GraphComponent } from './components/graph/graph.component';
import { GraphManagerComponent } from './components/graph-manager/graph-manager.component';
import { GraphDimoiComparedComponent } from './components/graph-dimoi-compared/graph-dimoi-compared.component';
import { GraphPe1Component } from './components/graph-pe1/graph-pe1.component';
import { GraphPe2Component } from './components/graph-pe2/graph-pe2.component';
import { GraphPopupComponent } from './components/graph-popup/graph-popup.component';
import { YearSelectorComponent } from './components/year-selector/year-selector.component';
import { LegendComponent } from './components/legend/legend.component';

@NgModule({
  declarations: [
    AppComponent,
    MapComponent,
    TimeBarComponent,
    PropertySelectorComponent,
    GraphComponent,
    GraphManagerComponent,
    GraphDimoiComparedComponent,
    GraphPe1Component,
    GraphPe2Component,
    GraphPopupComponent,
    YearSelectorComponent,
    LegendComponent
  ],
  imports: [
    BrowserModule, SliderModule, HttpModule, ChartModule, DialogModule, BrowserAnimationsModule
  ],
  providers: [
    { provide: APP_BASE_HREF, useValue: environment.baseRef },
    ContextService, TimeService, ApiService, DataService, ColorService, PeProviderService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/sofos/projects/anadigit/kounoupia-frontend/src/app/app.module.ts